import {
  ChevronLeftIcon,
  EditIcon,
  IconButton,
  PictureIcon,
} from '@paypalcorp/pp-react'
import React from 'react'
import { useAppDispatch } from '../../../store/hooks'
import { toggleUpdateCoverImage } from '../../../store/slices/sheetsSlice'
import { useLocalizedContent } from '../../../hooks/useLocalizedContent'
import * as styles from '../index.css'
import * as stripStyles from './strip.css'
import { COVER_IMAGE_DEFAULT_IMAGE_URL } from '../../../constants'
import {
  isCoverOnCreateFlowEnabled,
  isDetailsV1Dot1Enabled,
} from '../../../utils/features'
import { Message } from '@paypalcorp/worldready-react'
import { tracking } from '../../../lib/analytics/fpti'
import Events from '../../../lib/analytics/eventTags.js'
import serverData from '../../../utils/server-data'

interface StripProps {
  backgroundImage?: string
  displayEditButton?: boolean
  onEditButtonClick?: () => void
  displayBackButton?: boolean
  onBackButtonClick?: () => void
  groupId?: string
}

const Strip = ({
  backgroundImage,
  displayBackButton = false,
  displayEditButton = false,
  onBackButtonClick,
  onEditButtonClick,
  groupId,
}: StripProps) => {
  const dispatch = useAppDispatch()
  const { getContent } = useLocalizedContent()
  const createFlowEnabled = isCoverOnCreateFlowEnabled()
  const useDetailV1Dot1 = isDetailsV1Dot1Enabled()

  const backgroundImageDef = backgroundImage
    ? backgroundImage
    : COVER_IMAGE_DEFAULT_IMAGE_URL
  const imgStyle = useDetailV1Dot1 ? stripStyles.imgStyle : styles.imgStyle
  const stripStyleName = backgroundImage
    ? 'imageStripDivStyles'
    : 'imageStripNoImage'
  const stripStyle = useDetailV1Dot1
    ? stripStyles[stripStyleName]
    : styles[stripStyleName]

  const shouldRenderUpdateCoverButton =
    !createFlowEnabled && !useDetailV1Dot1 && displayEditButton

  const handleClickUpdateCoverImage = () => {
    tracking(
      Events.p2p_pools_detail_edit_image_pressed({
        source: serverData.trackingParameters.externalSource,
        page_variant: 'creator',
        pool_id: groupId,
      }),
    )
    dispatch(toggleUpdateCoverImage())
  }

  return (
    <div className={stripStyle} data-testid="strip-container">
      <img
        alt=""
        src={backgroundImageDef}
        className={imgStyle}
        aria-hidden="true"
      />
      {useDetailV1Dot1 && (
        <>
          {displayBackButton && onBackButtonClick && (
            // TODO: Aria label for the back button
            <IconButton
              className={stripStyles.imageBack}
              onClick={onBackButtonClick}
              svgIconComponent={ChevronLeftIcon}
              buttonType="secondary"
              size="sm"
              data-testid="strip-back-button"
            >
              <Message id="create.cover.image.edit" />
            </IconButton>
          )}
          {displayEditButton && onEditButtonClick && (
            <IconButton
              className={stripStyles.imageEdit}
              onClick={onEditButtonClick}
              svgIconComponent={EditIcon}
              buttonType="secondary"
              size="sm"
              data-testid="strip-edit-button"
            >
              <Message id="create.cover.image.edit" />
            </IconButton>
          )}
        </>
      )}
      {shouldRenderUpdateCoverButton && (
        <button
          aria-label={getContent('create.cover.image.edit')}
          className={styles.imageEdit}
          onClick={handleClickUpdateCoverImage}
          data-testid="strip-update-cover-button"
        >
          <PictureIcon size="sm" />
        </button>
      )}
    </div>
  )
}

export default Strip
